var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Container, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import ActivityStatus from '../../../data/ActivityStatus';
import AssetCollection from '../../../collections/assets/AssetCollection';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import AssetDetailWidget from './details/AssetDetailWidget';
import AssetDetailLabels from './details/AssetDetailLabels';
import AssetDetailRemarkField from './details/AssetDetailRemarkField';
import AssetServiceSchemas from './serviceEntries/AssetServiceSchemas';
import AssetServiceEntries from './serviceEntries/AssetServiceEntries';
import { SystemFeatureToggle } from '../../../data/SystemFeatureToggle';
import ArchiveAssetOverlay from './ArchiveAssetOverlay';
import Feature from "../../components/ui/Feature/Feature";
import AssetMetrics from "./history/AssetMetrics";
export var AssetDetailTabs;
(function (AssetDetailTabs) {
    AssetDetailTabs[AssetDetailTabs["ASSET_DETAILS"] = 1] = "ASSET_DETAILS";
    AssetDetailTabs[AssetDetailTabs["ASSET_SCHEMAS"] = 2] = "ASSET_SCHEMAS";
    AssetDetailTabs[AssetDetailTabs["ASSET_SERVICE_ENTRIES"] = 3] = "ASSET_SERVICE_ENTRIES";
    AssetDetailTabs[AssetDetailTabs["ASSET_SERVICE_HISTORY"] = 4] = "ASSET_SERVICE_HISTORY";
})(AssetDetailTabs || (AssetDetailTabs = {}));
/**
 *
 */
var AssetDetail = /** @class */ (function (_super) {
    __extends(AssetDetail, _super);
    /**
     *
     * @param props
     */
    function AssetDetail(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { activeTab: AssetDetailTabs.ASSET_DETAILS, assetModel: null, showing: false };
        _this.onArchive = _this.onArchive.bind(_this);
        _this.onShowAsset = _this.onShowAsset.bind(_this);
        _this.onHideAsset = _this.onHideAsset.bind(_this);
        _this.refreshAssetData = _this.refreshAssetData.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetDetail.prototype.componentDidMount = function () {
        Signals.ShowAssetDetail.add(this.onShowAsset);
        Signals.HideAssetDetail.add(this.onHideAsset);
        Signals.AssetsRetrieved.add(this.refreshAssetData);
    };
    /**
     *
     */
    AssetDetail.prototype.componentWillUnmount = function () {
        Signals.ShowAssetDetail.remove(this.onShowAsset);
        Signals.HideAssetDetail.remove(this.onHideAsset);
        Signals.AssetsRetrieved.remove(this.refreshAssetData);
    };
    AssetDetail.prototype.refreshAssetData = function () {
        var _a = this.context.assetCollection, assetCollection = _a === void 0 ? AssetCollection : _a;
        var assetModel = this.state.assetModel;
        var intl = this.props.intl;
        // If there is no assetmodel in the state it means it is also not showing
        // We can also skip the find in the list since we won't find an asset
        var refreshedAssetModel = assetModel ? assetCollection.list.find(function (asset) { return asset.getMetricsDbId() == assetModel.getMetricsDbId(); }) : null;
        // If the asset is not found,
        // f.e. an asset is archived on a different client 
        // Or the session is timed out
        if (refreshedAssetModel) {
            this.setState({ assetModel: refreshedAssetModel });
        }
        else {
            if (this.state.showing) {
                // Feedback to the user and close the detail screen
                Signals.ShowNotification.dispatch(intl.formatMessage({ id: "asset.detail.assetNotFound" }), "danger");
                Signals.HideAssetDetail.dispatch();
            }
        }
    };
    /**
     *
     */
    AssetDetail.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var user = session.user;
        var _a = this.props, className = _a.className, intl = _a.intl;
        var _b = this.state, assetModel = _b.assetModel, showing = _b.showing;
        var activeTab = this.state.activeTab;
        if (!user) {
            return null;
        }
        if (!assetModel && showing) {
            // Asset not found
            // Feedback to the user and close the detail screen
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "asset.detail.assetNotFound" }), "danger");
            Signals.HideAssetDetail.dispatch();
        }
        var locationTimeClasses = '';
        if (assetModel) {
            switch (assetModel.properties.activityStatus) {
                case ActivityStatus.EXPIRED:
                    locationTimeClasses = 'fe fe-alert-circle text-warning mr-2';
                    break;
                case ActivityStatus.NONE:
                    locationTimeClasses = 'fe fe-x-circle text-danger mr-2';
                    break;
                case ActivityStatus.RECENT:
                    locationTimeClasses = 'fe fe-clock mr-2';
                    break;
            }
        }
        var classes = classNames({
            'asset-detail w-100': true,
            'asset-detail--showing': showing,
            'asset-detail--large': activeTab === AssetDetailTabs.ASSET_SERVICE_HISTORY,
        });
        var navKey = 0;
        return React.createElement(Container, { className: classes + ' ' + className },
            assetModel &&
                React.createElement(Card, { className: "box-shadow" },
                    React.createElement(CardHeader, { className: "flex-grow-0 pb-0" },
                        React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                            React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' }, assetModel.properties.displayedId))),
                    React.createElement(CardBody, { className: "d-flex flex-column py-0" },
                        React.createElement(Nav, { tabs: true, className: "border-0" },
                            React.createElement(NavItem, { key: 'nav-' + (navKey++) },
                                React.createElement(NavLink, { className: classNames({ active: activeTab === AssetDetailTabs.ASSET_DETAILS }), onClick: function () {
                                        _this.setState({ activeTab: AssetDetailTabs.ASSET_DETAILS });
                                    } },
                                    React.createElement(FormattedMessage, { id: "asset.detail.tab.default.title", defaultMessage: "Machine details" }))),
                            React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK] },
                                React.createElement(NavItem, { key: 'nav-' + (navKey++) },
                                    React.createElement(NavLink, { className: classNames({ active: activeTab === AssetDetailTabs.ASSET_SCHEMAS }), onClick: function () {
                                            _this.setState({ activeTab: AssetDetailTabs.ASSET_SCHEMAS });
                                        } },
                                        React.createElement(FormattedMessage, { id: "asset.detail.tab.schemas", defaultMessage: "Schemas" }))),
                                React.createElement(NavItem, { key: 'nav-' + (navKey++) },
                                    React.createElement(NavLink, { className: classNames({ active: activeTab === AssetDetailTabs.ASSET_SERVICE_ENTRIES }), onClick: function () {
                                            _this.setState({ activeTab: AssetDetailTabs.ASSET_SERVICE_ENTRIES });
                                        } },
                                        React.createElement(FormattedMessage, { id: "asset.detail.tab.serviceentries", defaultMessage: "Meldingen" })))),
                            React.createElement(Feature, { hasAny: [SystemFeatureToggle.METRICS] },
                                React.createElement(NavItem, { key: 'nav-' + (navKey++) },
                                    React.createElement(NavLink, { className: classNames({ active: activeTab === AssetDetailTabs.ASSET_SERVICE_HISTORY }), onClick: function () {
                                            _this.setState({ activeTab: AssetDetailTabs.ASSET_SERVICE_HISTORY });
                                        } },
                                        React.createElement(FormattedMessage, { id: "asset.detail.tab.history", defaultMessage: "Geschiedenis" }))))),
                        React.createElement(TabContent, { className: "overflow-auto bg-white px-4 pt-4 flex-fill mt-3", style: { borderRadius: "10px" }, activeTab: activeTab },
                            React.createElement(TabPane, { tabId: AssetDetailTabs.ASSET_DETAILS },
                                React.createElement(Row, null,
                                    React.createElement(Col, { sm: 12, className: "mb-3" }, activeTab === AssetDetailTabs.ASSET_DETAILS ? React.createElement(React.Fragment, null,
                                        React.createElement(AssetDetailWidget, { assetModel: assetModel }),
                                        React.createElement(AssetDetailLabels, { assetModel: assetModel, showing: showing && activeTab === 1 }),
                                        React.createElement(AssetDetailRemarkField, { assetModel: assetModel }),
                                        " ") : null))),
                            React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK] },
                                React.createElement(TabPane, { key: AssetDetailTabs.ASSET_SCHEMAS, tabId: AssetDetailTabs.ASSET_SCHEMAS },
                                    React.createElement(Row, null,
                                        React.createElement(Col, { sm: 12 }, activeTab === AssetDetailTabs.ASSET_SCHEMAS &&
                                            React.createElement(AssetServiceSchemas, { assetModel: assetModel })))),
                                React.createElement(TabPane, { key: AssetDetailTabs.ASSET_SERVICE_ENTRIES, tabId: AssetDetailTabs.ASSET_SERVICE_ENTRIES },
                                    React.createElement(Row, null,
                                        React.createElement(Col, { sm: 12 }, activeTab === AssetDetailTabs.ASSET_SERVICE_ENTRIES &&
                                            React.createElement(AssetServiceEntries, { assetModel: assetModel }))))),
                            React.createElement(Feature, { hasAny: [SystemFeatureToggle.METRICS] },
                                React.createElement(TabPane, { key: AssetDetailTabs.ASSET_SERVICE_HISTORY, tabId: AssetDetailTabs.ASSET_SERVICE_HISTORY },
                                    React.createElement(Row, null,
                                        React.createElement(Col, { sm: 12 }, activeTab === AssetDetailTabs.ASSET_SERVICE_HISTORY &&
                                            React.createElement(AssetMetrics, { assetModel: assetModel }))))))),
                    React.createElement(CardFooter, null, session.user && session.user.isOwner &&
                        React.createElement("div", null, !assetModel.isArchived &&
                            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.onArchive },
                                React.createElement("i", { className: "fe fe-archive" }),
                                " ",
                                React.createElement(FormattedHTMLMessage, { id: "asset.archive", values: { assetId: assetModel.id } }))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideAssetDetail.dispatch();
                } }));
    };
    /**
     *
     */
    AssetDetail.prototype.onArchive = function () {
        var assetModel = this.state.assetModel;
        Signals.ShowOverlay.dispatch(React.createElement(ArchiveAssetOverlay, { assetModel: assetModel }));
    };
    /**
     *
     * @param assetModel
     * @param activeTab
     */
    AssetDetail.prototype.onShowAsset = function (assetModel, activeTab) {
        if (activeTab === void 0) { activeTab = null; }
        if (activeTab) {
            this.setState({ assetModel: assetModel, showing: true, activeTab: activeTab });
        }
        else {
            this.setState({ assetModel: assetModel, showing: true });
        }
    };
    /**
     *
     */
    AssetDetail.prototype.onHideAsset = function () {
        this.setState({ showing: false });
    };
    AssetDetail.defaultProps = {
        className: ''
    };
    AssetDetail = __decorate([
        observer
    ], AssetDetail);
    return AssetDetail;
}(React.Component));
AssetDetail.contextType = ApplicationContext;
export default injectIntl(AssetDetail);
